var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReport = function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".report_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 7.999,
    r: 4,
    className: "report_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.171 10.218 9.5 7.999v-4",
    className: "report_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.207 4.5a1 1 0 0 1 .293.707V22.5a1 1 0 0 1-1 1h-17a1 1 0 0 1-1-1v-21a1 1 0 0 1 1-1h13.293a1 1 0 0 1 .707.291ZM16 5.499h2.5M5.5 14.499h13M5.5 17.499h13M5.5 20.499h13M16 8.499h2.5M16 11.499h2.5",
    className: "report_svg__a"
  })));
};
export default SvgReport;